import BaseModelFactory from './base.factory'
import EliteAgencyTeamService from './../services/EliteAgencyTeam.service'
import EliteAgencyTeam from './../models/elite-agency-team.model'

class EliteAgencyTeamFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: EliteAgencyTeamService, Model: EliteAgencyTeam }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: EliteAgencyTeamService, Model: EliteAgencyTeam })
  static findAllById = async id =>
    await this._findAllBy({ id: id }, { Service: EliteAgencyTeamService, Model: EliteAgencyTeam })
  static create = payload =>
    this._create(payload, {
      Service: EliteAgencyTeamService,
      Model: EliteAgencyTeam,
    })
}

export default EliteAgencyTeamFactory
